/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/plot_medium'
export default icon
